const apiEndpoints = {
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  VERIFY_OTP: '/api/auth/verify-otp',
  RESEND_OTP: '/api/auth/resend-otp',
  GENERATE_ACCESS_TOKEN: '/api/auth/generate-access-token',
  ONBOARDING_START: '/api/onboarding/start',
  RISK_PROFILE: '/api/onboarding/risk-profile',
  SOURCE_OF_FUNDS: '/api/onboarding/source-of-funds',
  KYC_CREATE_SESSION: '/api/kyc/create-session',
  KYC_START_SESSION: '/api/kyc/start-session',
  KYC_DETAILS: '/api/kyc/details',
  KYC_REVIEW: '/api/kyc/kyc-review',
  KYC_RE_INITIATE: '/api/kyc/re-initiate',
  LOGOUT: '/api/logout',
  COUNTRIES: '/api/countries',
  USER_PROFILE: '/api/user/profile',
  UPDATE_PROFILE: '/api/user/profile',
  ACCOUNT_STATUS: '/api/account/status',
  BANK_ACCOUNTS: '/api/bank-accounts',
  INVESTMENTS: '/api/investments',
  PORTFOLIO: '/api/portfolio',
  MARKETS: '/api/admin/masters/markets',
  ADMIN_COUNTRIES: '/api/admin/masters/countries',
  PLATFORM_SETTINGS: '/api/admin/masters/platform-settings',
  MARKET_SETTINGS: '/api/admin/masters/market-settings',
  MARKET_COUNTRIES: '/api/admin/masters/market-countries',
  PROPERTY_SETTINGS: '/api/admin/masters/property-settings',
  MEDIA_CATEGORIES: '/api/admin/masters/media-categories',
  PROPERTY_TYPE_MEDIA_SETTINGS: '/api/admin/masters/property-type-media-settings',
  AMENITIES_MASTER: '/api/admin/masters/amenities',
  HIGHLIGHT_TEMPLATES: '/api/admin/masters/highlight-templates',
  PROPERTIES: '/api/admin/properties',
  PROPERTY_OWNERS: '/api/admin/property-owners',
  ORDERS: '/api/admin/orders',
  INVESTORS: '/api/admin/investors',
  INVESTOR_BANK_ACCOUNTS: '/api/admin/investors/bank-accounts',
  WALLET_TRANSACTIONS: '/api/wallets/fiat/transactions',
  WALLET_TRANSACTIONS_REVIEW: '/api/wallets/fiat/transactions/review',
  FEE_STRUCTURE: '/api/fee-structure',
}

export default apiEndpoints
